import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiSiteSeo, StrapiSingleResponse } from '@ts-strapi/interfaces'
// hooks
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface UseStrapiSiteSeoReturn {
  refSiteSeo: ComputedRef<StrapiSiteSeo | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
  refresh: () => Promise<void>
}

export const useStrapiSiteSeo = async (): Promise<UseStrapiSiteSeoReturn> => {
  const strapiFetch = useStrapiFetch()

  const { data, pending, error, refresh } = await useAsyncData(
    'strapi:site-seo',
    () => strapiFetch<StrapiSingleResponse<StrapiSiteSeo>>('/site-seo', {
      params: {
        'populate[organizationLogo]': 'true',
        'populate[defaultOgImage]': 'true',
        'populate[msTileImage]': 'true',
        'populate[sameAs]': 'true',
      },
    }),
  )

  return {
    refSiteSeo: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
    refresh: () => refresh(),
  }
}